module.exports = __webpack_public_path__ + "static/logo-original-044da8d260a62e67e7a643277d8ae77a.svg";